// extracted by mini-css-extract-plugin
module.exports = {"section":"table_section__XLtfu","overlay":"table_overlay__W3sZV","container":"table_container__Y0yYJ"};